import { render, staticRenderFns } from "./PolicyContent.vue?vue&type=template&id=782646ce&scoped=true"
import script from "./PolicyContent.vue?vue&type=script&lang=js"
export * from "./PolicyContent.vue?vue&type=script&lang=js"
import style0 from "./PolicyContent.vue?vue&type=style&index=0&id=782646ce&prod&lang=less&scoped=true"
import style1 from "./PolicyContent.vue?vue&type=style&index=1&id=782646ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782646ce",
  null
  
)

export default component.exports